import { render, staticRenderFns } from "./DialogCheckbox.vue?vue&type=template&id=3ca1f1e8"
import script from "./DialogCheckbox.vue?vue&type=script&lang=js"
export * from "./DialogCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports